(() => {
  if (window.productCardRatingInitialized) return;
  window.productCardRatingInitialized = true;

  const selector = '[data-product-card] .ruk_rating_snippet';

  function updateRating(snippet) {
    const labels = [snippet.getAttribute('aria-label') || '', snippet.getAttribute('title') || ''];
    const match = labels.map((label) => label.match(/^\s*(\d+(?:\.\d+)?)\s+Stars?\s*-\s*([\d,]+)\s+Reviews?\s*$/i)).find(Boolean);
    const countLabel = snippet.querySelector('.ruk-rating-snippet-count')?.textContent.trim() || '';
    const empty = !match && (
      /^\(?\s*0\s*(?:Reviews?)?\s*\)?$/i.test(countLabel) ||
      labels.some((label) => /^\s*(?:No reviews(?: yet)?|\(?0\s+Reviews?\)?)\s*[.!]?\s*$/i.test(label))
    );
    const reviewCount = match ? match[2] : '0';
    const rating = match ? Number(match[1]) : empty ? 0 : NaN;
    if (!Number.isFinite(rating) || rating < 0 || rating > 5) {
      snippet.removeAttribute('data-compact-rating');
      snippet.querySelector('.product-card__compact-rating')?.remove();
      return;
    }

    let compact = snippet.querySelector('.product-card__compact-rating');
    if (!compact) {
      compact = document.createElement('span');
      compact.className = 'product-card__compact-rating';
      compact.setAttribute('aria-hidden', 'true');

      const star = document.createElement('span');
      star.className = 'product-card__compact-rating-star';
      star.textContent = '★';
      const value = document.createElement('span');
      value.className = 'product-card__compact-rating-value';
      const count = document.createElement('span');
      count.className = 'product-card__compact-rating-count';
      compact.append(star, value, count);
      snippet.appendChild(compact);
    }

    const value = compact.querySelector('.product-card__compact-rating-value');
    const count = compact.querySelector('.product-card__compact-rating-count');
    const ratingText = rating.toFixed(1);
    const countText = `(${reviewCount})`;
    if (value.textContent !== ratingText) value.textContent = ratingText;
    if (count.textContent !== countText) count.textContent = countText;
    if (!snippet.hasAttribute('data-compact-rating')) snippet.setAttribute('data-compact-rating', '');
  }

  const pending = new Set();
  let scheduled = false;

  function queueRatings(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    const snippet = node.closest('.ruk_rating_snippet');
    if (snippet?.matches(selector)) pending.add(snippet);
    node.querySelectorAll(selector).forEach((rating) => pending.add(rating));
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      // Updates inside an existing snippet may replace its generated markup.
      const target = mutation.target.nodeType === Node.ELEMENT_NODE
        ? mutation.target : mutation.target.parentElement;
      if (target) {
        const snippet = target.closest('.ruk_rating_snippet');
        if (snippet?.matches(selector)) pending.add(snippet);
      }
      mutation.addedNodes.forEach(queueRatings);
    });
    if (!pending.size || scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      const ratings = [...pending];
      pending.clear();
      ratings.forEach((snippet) => {
        if (snippet.isConnected && snippet.matches(selector)) updateRating(snippet);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    characterData: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['title', 'aria-label'],
  });
  document.querySelectorAll(selector).forEach(updateRating);
})();
